export const star = () => `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
    <path 
        d="M11.7216 1.81663C12.0884 1.07346 13.1482 1.07346 13.515 1.81663L16.2849 7.42814C16.4304 7.72299 16.7116 7.92745 17.037 7.97501L23.2328 8.88062C24.0527 9.00046 24.3795 10.0083 23.7859 10.5865L19.3042 14.9516C19.0684 15.1814 18.9607 15.5125 19.0164 15.837L20.0738 22.0026C20.2139 22.8196 19.3564 23.4426 18.6228 23.0567L13.0837 20.1438C12.7924 19.9906 12.4442 19.9906 12.1528 20.1438L6.61382 23.0567C5.88019 23.4426 5.02264 22.8196 5.16276 22.0026L6.22023 15.837C6.2759 15.5125 6.16823 15.1814 5.93236 14.9516L1.45068 10.5865C0.857086 10.0083 1.18387 9.00046 2.00378 8.88062L8.19961 7.97501C8.52496 7.92745 8.80615 7.72299 8.95169 7.42814L11.7216 1.81663Z" 
        fill="inherit"
        stroke="inherit" 
        stroke-linecap="round" 
        stroke-linejoin="round"
    />
    </svg>
    `;
